<template>
    <el-dialog
      width='500px'
      :visible='msgShow'
      @close='msgClose'
    >
    <div class='msg_text'>{{msg}}</div>
    </el-dialog>
</template>

<script>
export default {
  name: 'msgPopup',
  data () {
    return {
    }
  },
  props: {
    msg: {
      type: String,
      default: ''
    },
    msgShow: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  methods: {
    msgClose () {
      this.$emit('msgClose')
    }
  }
}
</script>

<style>
    .el-dialog {
      border-radius: 15px;
      margin: 0 !important;
    }
    .el-dialog__body {
      padding: 0px 20px !important;
      transform: translate3d(0, 0, 0);
      overflow: auto;
      height: 90%;
    }
    .el-dialog__wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .msg_text {
      font-size: 14px;
      font-weight: 200;
      font-family: PingfangScBold;
      color: #e85141;
      line-height: 30px;
      letter-spacing: 1px;
      text-align: center;
      margin-top:30px;
      margin-bottom: 70px;
    }
</style>



// WEBPACK FOOTER //
// src/components/home/popup/msgPopup.vue